<template>
    <InformeCard title="Gráfico desglosado del total de recaudación">
        <b-row>
            <b-col cols="12">
                <GChart
                    type="PieChart"
                    :data="chartData"
                    :options="chartOptions"
                    style="width: 100%; height: 300px;"
                />
            </b-col>
        </b-row>
    </InformeCard>
</template>

<script>
    import InformeCard from '@/components/backend/estadisticas/InformeCard';

    export default {
        name: 'GraficoTotalRecaudacion',
        props: {
            estadisticas: {
                type: Object,
                required: true
            }
        },
        computed: {
            chartData() {
                return [
                    ['Canal', 'Cantidad'],
                    ['Online', this.estadisticas.count_online],
                    ['Taquilla', this.estadisticas.count_taquilla]
                ];
            },
            chartOptions() {
                const total = this.estadisticas.total_parcelas || 0;

                return {
                    title: `Distribución Parcelas (Total: ${total})`,
                    pieSliceText: 'value',
                    colors: ['#36A2EB', '#FF6384']
                };
            }
        },
        components: {
            InformeCard
        }
    };
</script>
